import React from 'react';

/** Monogram/photo avatar matching the prototype's .ava. */
export function Avatar({ src, init, size }) {
  const cls = 'ava' + (size === 'lg' ? ' ava--lg' : size === 'sm' ? ' ava--sm' : '');
  if (src) return <img className={cls} src={src} alt="" />;
  return (
    <span
      className={cls}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'var(--mono)', letterSpacing: '0.05em',
        fontSize: size === 'lg' ? 15 : size === 'sm' ? 10 : 12,
        color: 'var(--cream-dim)', textTransform: 'uppercase',
      }}
    >
      {init}
    </span>
  );
}

/** Gold key — marks a Key Holder (unlimited invites). */
export function KeyIcon({ title }) {
  return (
    <span className="keyicon" title={title || 'Key holder · unlimited keys'} aria-label={title || 'Key holder'}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="8.5" cy="8.5" r="4.3" />
        <line x1="11.6" y1="11.6" x2="20" y2="20" />
        <line x1="17.4" y1="17.4" x2="20" y2="14.8" />
        <line x1="14.8" y1="14.8" x2="17" y2="12.6" />
      </svg>
    </span>
  );
}

export function initials(name) {
  return (name || '?').trim().split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase();
}
